import angular from 'angular';
import d3 from 'd3';
import { wrapLabels } from './hvr-chart-helpers';
import { isNil } from 'lodash';

import {} from './od-hvr-charts.less';

module.exports = angular.module('market.components.od-hvr-grouped-bar-chart', [])
.component('odHvrGroupedBarChart', {
  bindings: {
    data: '<',
  },
  controller: class {
    constructor($element, $mediaQuery) {
      this.$element = $element;

      this.elemWidth = 520;
      this.elemHeight = 300;
      if (!$mediaQuery('gt-md')) {
        this.elemWidth = 400;
        this.elemHeight = 250;
      }
      if (!$mediaQuery('gt-sm')) {
        this.elemWidth = 520;
        this.elemHeight = 350;
      }
      if (!$mediaQuery('gt-xs')) {
        this.elemWidth = 300;
        this.elemHeight = 250;
      }

      $element.append(`
        <svg
          width="${this.elemWidth}"
          height="${this.elemHeight}"
          viewbox="0 0 ${this.elemWidth} ${this.elemHeight}"
          preserveaspectratio="xMidYMid meet"
        >
        </svg>
      `);

      this.buildChart($element.find('svg'));
    }

    buildChart(chartElement) {
      if (isNil(this.data)) {
        return;
      }
      let data = this.data;

      let legendIconUrl = 'https://images.opendoor.com/source/s3/imgdrop-production/hvr-label-neighborhood.svg?service=web';
      let iconWidth = 227;
      let iconHeight = 13;

      let dataKeys = d3.keys(data[0]).filter((key) => key !== "label");

      let svg_elem = d3.select(chartElement[0]);
      let margin = { top: 60, right: 20, bottom: 60, left: 40 };
      let width = this.elemWidth - margin.left - margin.right;
      let height = this.elemHeight - margin.top - margin.bottom;

      // spacing between bars: 0.5 (almost none) to 1.0 (so much spacing, can't even see the bars!)
      let x0 = d3.scale.ordinal().rangeRoundBands([0, width], .30);
      let x1 = d3.scale.ordinal();
      let y = d3.scale.linear().range([height, 0]);

      let xAxis = d3.svg.axis()
        .scale(x0)
        .orient("bottom");

      let yAxis = d3.svg.axis()
        .scale(y)
        .orient("left")
        .ticks(10)
        .tickFormat(d3.format("%"));

      let svg = svg_elem.attr("width", width + margin.left + margin.right)
               .attr("height", height + margin.top + margin.bottom)
               .append("g")
               .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      data.forEach((d) => {
        d.values = dataKeys.map((name) => ({ name: name, value: +d[name] }));
      });

      x0.domain(data.map((d) => d.label));
      x1.domain(dataKeys).rangeRoundBands([0, x0.rangeBand()]);
      y.domain([0, d3.max(data, (d) => d3.max(d.values, (d) => d.value))]);

      // Draw the X-axis line
      svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .call(wrapLabels, x0.rangeBand());

      // Draw the Y-axis line
      svg.append("g")
        .attr("class", "y axis")
        .call(yAxis.ticks(5))
        .append("text")
        .attr("class", "text-label-y")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".70em")
        .style("text-anchor", "end");

      // Draw the Y grid lines
      svg.append("g")
        .attr("class", "grid")
        .call(d3.svg.axis()
          .scale(y)
          .orient("left")
          .ticks(5)
          .tickSize(-width, 0, 0)
          .tickFormat("")
        );

      let bar = svg.selectAll("bar")
        .data(data)
        .enter().append("g")
        .attr("class", "rect")
        .attr("transform", (d) => `translate(${x0(d.label)},0)`);

      // TODO: "phoenix" is hardcoded in the response we get, but switch to something like
      // "market" to be more future-proof. Will also need to update the legend icon below.
      bar.selectAll("rect")
        .data((d) => d.values)
        .enter().append("rect")
        .attr("class", (d) => {
          if (d.name === "phoenix") {
            return "freq-bars";
          } else {
            return "subj-bar";
          }
        })
        .attr("width", x1.rangeBand() - 5)
        .attr("x", (d) => x1(d.name))
        .attr("y", (d) => y(d.value))
        .attr("value", (d) => d.name)
        .attr("height", (d) => height - y(d.value));

      svg.append("svg:image")
        .attr('x', width - iconWidth)
        .attr('y', -40)
        .attr('width', iconWidth)
        .attr('height', iconHeight)
        .attr("xlink:href", legendIconUrl);
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/hvr-charts/od-hvr-grouped-bar-chart.js
 **/